import { addTraits } from 'src/api';
import { getUser } from 'src/user';

export const getAccount = state => addTraits(state.account.account);
export const getTask = state => {
  return addTraits(state.account.account.data.tasks)
};

export const getAccountFI = state => {
  const user = getUser(state);
  const account = getAccount(state);

  if (user.financialInstitutionId && account.financialInstitutions) {
    return account.financialInstitutions.filter(
      fi => fi.id === user.financialInstitutionId
    )[0];
  }

  return null;
};
